import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {PlanningCommonService} from "../../../planning/services/planning-coomon-service.service";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {ResizerService} from "../../../commons/services/resizer.service";

export class planningDispatchRouteTimelineCtrl implements IController {
  route: any;
  tasksListType?: any;
  suggestions: any;
  highlightTaskId: any;
  selectedSuggestionIds: any;
  suggestionsServiceAreas?: any;
  canEdit: any;
  onTaskSelection: Function;
  onMoveItem: Function;
  onAddSuggestedServices: Function;
  onRefreshSuggestions: Function;
  onSelectSuggestion: Function;
  onToggleSuggestionsSelection: Function;
  onSuggestionsServiceAreasChange: Function;


  public timelineEnabled: boolean = false;
  public timelineRange: any;
  public isMouseVerticalDown: boolean;
  public selectedLeftOverJobIds: any;
  public leftOvers: any;


  constructor(private resizerService: ResizerService, private leanPlanningConstants, private resizeService: ResizeService,
              private planningCommonService: PlanningCommonService, private TimelineService) {
  }


  $onInit() {
    this.timelineRange = this.TimelineService.getTimelineRange([this.route]);
    this.isMouseVerticalDown = false;
  };

  $onChanges(changes) {
    if (changes.route) {
      this.timelineRange = this.TimelineService.getTimelineRange([this.route]);
    }
  };


  isLeftOverSelected(job) {
    return _.includes(this.selectedLeftOverJobIds, job.id);
  }

  getAllDraggedLeftOverJobs(draggedJob) {
    var isDraggedSelected = this.isLeftOverSelected(draggedJob);
    return isDraggedSelected ?
      _.filter(this.leftOvers, (job) => {
        return _.includes(this.selectedLeftOverJobIds, job.id);
      }) : [draggedJob]
  }

  onToggleTimeline() {
    this.timelineEnabled = !this.timelineEnabled;
    this.resizeService.resize();
  }

  onLeftOversScroll(scrollLeft) {
    const container = document.querySelector('div.left-overs-container');
    if (scrollLeft) {
      container.scrollLeft -= 500
    } else {
      container.scrollLeft += 500
    }
  }
}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningDispatchRouteTimeline', {
    bindings: {
      route: '<',
      tasksListType: '<?',
      suggestions: '<',
      highlightTaskId: '<',
      selectedSuggestionIds: '<',
      suggestionsServiceAreas: '<?',
      canEdit: '<',
      onTaskSelection: '&',
      onMoveItem: '&',
      onAddSuggestedServices: '&',
      onRefreshSuggestions: '&',
      onSelectSuggestion: '&',
      onToggleSuggestionsSelection: '&',
      onSuggestionsServiceAreasChange: '&'
    },
    template: require('./planning-dispatch-route-timeline.html').default,
    controller: planningDispatchRouteTimelineCtrl
  });
